import React from "react";
import styles from "../styles/MenuModalLoggedIn.module.css";
import styles2 from "../styles/HeaderLoggedIn.module.css";
import DropDownLoggedInHeader from "./DropDownLoggedInHeader";
import { useNavigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { ROLES } from "../config/roles";
import { useTranslation } from "react-i18next";

export default function MenuModalLoggedIn({ toggleModal, setToggleModal }) {
  const { t } = useTranslation(["Header"]);
  const navigate = useNavigate();
  const { roles } = useAuth();
  const isAdmin = roles.some((role) => [ROLES.Admin].includes(role));
  return (
    <div
      onClick={() => setToggleModal(!toggleModal)}
      className={`${styles.modal} ${toggleModal && styles.active}`}
    >
      {/* <!-- Modal content --> */}
      <div
        className={`${styles.modal_content} ${
          toggleModal === false ? styles.inactive : ""
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className={styles.closeBtn}
          onClick={() => setToggleModal(!toggleModal)}
        >
          <img
            src="/icons/bidd/close_cross.svg"
            alt="cross"
            className={styles.closeIcon}
          />
        </div>

        <div className={styles.linksContainer}>
          <div className={styles.profileContainer}>
            <DropDownLoggedInHeader
              mobileView={toggleModal}
              setToggleModal={setToggleModal}
            />
          </div>

          <div className={styles2.navLinks}>
            {isAdmin && (
              <div
                className={`${styles2.linkContainer} ${styles2.active}`}
                onClick={() => navigate("/minar-sidur/users")}
              >
                {t("menuOptions.users")}
              </div>
            )}
          </div>
          <div className={styles2.navLinks}>
            {isAdmin && (
              <div
                className={`${styles2.linkContainer} ${styles2.active}`}
                onClick={() => navigate("/minar-sidur/companies")}
              >
                {t("menuOptions.companies")}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
